import { http } from 'api/apiConfig';
import { CUSTOMER_SEARCH_API_URL } from 'constants/endpoints';
export const fetchSearchResults = async (searchQuery, onlyActive) => {
    const { data } = await http.get(CUSTOMER_SEARCH_API_URL, {
        params: {
            q: searchQuery,
            status: onlyActive ? 'Active' : '',
        },
    });
    return data;
};
